import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  private tokenSubject = new BehaviorSubject<string | null>(this.getToken());
  token$ = this.tokenSubject.asObservable();

  private claimsSubject = new BehaviorSubject<any | null>(this.tokenSubject.value ? this.decodeToken(this.tokenSubject.value) : null);
  claims$ = this.claimsSubject.asObservable();

  currencySymbol$ = this.claims$.pipe(map((claims) => claims?.currencysymbol ?? ''));
  countryFlagCode$ = this.claims$.pipe(map((claims) => claims?.countryflagcode ?? ''));
  themeId$ = this.claims$.pipe(map((claims) => claims?.entityThemeId ?? null));
  timezoneUtc$ = this.claims$.pipe(map((claims) => claims?.timezoneutc ?? null));

  decodeToken<T = any>(token: string): T | null {
    try {
      return jwtDecode<T>(token);
    } catch (e) {
      console.error('Invalid JWT', e);
      return null;
    }
  }

  saveToken(token: string): void {
    localStorage.setItem('authToken', token);
    this.tokenSubject.next(token);
    this.claimsSubject.next(this.decodeToken(token));
  }

  removeToken() {
    localStorage.removeItem('authToken');
    this.tokenSubject.next(null);
    this.claimsSubject.next(null);
  }

  getToken() {
    return localStorage.getItem('authToken');
  }

  getClaims() {
    return this.claimsSubject.value;
  }

  getTimezoneUtc() {
    return this.getClaims()?.timezoneutc ?? null;
  }

  getCurrencySymbol() {
    return this.getClaims()?.currencysymbol ?? null;
  }

  getCountryFlagCode() {
    return this.getClaims()?.countryflagcode ?? null;
  }

  getThemeId() {
    return this.getClaims()?.entityThemeId ?? null;
  }

  getCountry() {
    return this.getClaims()?.country ?? '';
  }

  getEntityCode() {
    return this.getClaims()?.entity ?? '';
  }

  isGlobal() {
    return this.getCountry() === 'GLOBAL';
  }
}
